<template>
  <q-card class="col-12 q-mt-md">
    <q-card-section>
      <div class="col-12 row flex">
        <div class="col-8 row">
          <label class="label-contract">{{ data.chamado }}</label>
        </div>
        <div class="col-4 row flex justify-end">
          <label class="label-hours">{{
            formateHour(data.data_atualizacao)
          }}</label>
        </div>
      </div>
      <div class="col-12 row flex">
        <div class="col-6 row">
          <label class="label-date"
            >{{ data.justificativa }} <br />{{
              formateDate(data.data_atualizacao)
            }}</label
          >
        </div>
        <div class="col-6 row flex justify-end">
          <div
            class="card-status-geral flex justify-center items-center text-center q-pa-sm"
            :class="'status-2'"
          >
            <label>{{
              data.contingencia_ativa ? "Ativada" : "Desativada"
            }}</label>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import formatDate from "@/utils/dateFormat/dateFormate";

export default {
  name: "CardContingecyHistory",

  props: {
    data: Object,
  },
  setup() {
    function formateDate(data) {
      return formatDate(data);
    }

    function formateHour(data) {
      let date = formatDate(data);
      let hour = date.split(" ");
      return hour[3];
    }

    return {
      formateDate,
      formateHour,
    };
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.status-1 {
  background-color: #caebed;
}
.status-2 {
  background-color: #e0e0e0;
}
.status-3 {
  background-color: #dcd3e4;
}
.status-4 {
  background-color: #e5f6e3;
}
.status-5 {
  background-color: #e5f6e3;
}
.status-7 {
  background-color: #e5f6e3;
}

.label-contract {
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.label-hours {
  font-weight: 900;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.4);
}

.label-date {
  padding: 3% 0%;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.card-status-geral {
  width: 100%;

  label {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
